<template>
  <div v-if="!isLoadingData" class="modal">
    <div class="modal-dialog" v-click-outside="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5>Alert created</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div>
            The alert is now active, but will not trigger until tomorrow, after
            00:00 (UTC).
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="closeModal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as vClickOutside from 'v-click-outside';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'AlertActiveNoticeModal',
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState('alertsSuspiciousTrafficStore', ['isLoadingData'])
  },
  methods: {
    ...mapMutations('alertsSuspiciousTrafficStore', [
      'setIsShowAlertActiveNoticeModal'
    ]),

    closeModal() {
      this.setIsShowAlertActiveNoticeModal(false);
    }
  },
  mounted() {
    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        this.closeModal();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: 31.25rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;

  h5 {
    font-size: 1rem;
    margin: 0;
  }
}

.modal-body {
  margin: 0;
  padding: 1rem 1.5rem;

  .icon {
    margin-right: 0.5rem;
  }

  & > div {
    margin-bottom: 0.5rem;
  }
}

.modal-footer {
  padding: 1rem 1.5rem;
  justify-content: flex-end;
}
</style>
